import LeadDetails from '../leadDetails';

const TickdataCampaignsDetails = ({isOpen, onClose, showClass}) => {

    if (!isOpen) return null;
    
    return (
        <LeadDetails 
            isOpen={isOpen} 
            onClose={onClose} 
            leadName="tickdata"
            showClass={showClass}
        />
    );
};

export default TickdataCampaignsDetails;

